<div class="{{ OBJ_LNG_NAME }} uploadFile width100">

    <h1 mat-dialog-title>
        {{ 'allgemein.hochladen' | translate:locale.language:{ typ:  (nurBild ? 'bild.typ' : 'DATEI.typ') | translate:locale.language } }}
        <button mat-icon-button type="button" mat-dialog-close><mat-icon aria-label="Schließen">close</mat-icon></button>
        <mat-progress-bar *ngIf="seconddialogrunningajaxcall" color="primary" mode="indeterminate"></mat-progress-bar>
    </h1>
	<div class="uploadImageContent">

    <mat-dialog-content>

		<div class="dropzone-content-container">
		  <p class="errors" *ngIf="fehlerMain" [innerHTML]="fehlerMain.messagehtml"></p>
		  <dropzone class="dropzone dz-clickable"
					#uploadImageContainer
					[useDropzoneClass]="false"
					message="{{ 'bild.draghinweis' | translate:locale.language }}"
					[config]="dropzoneConfig"
					(error)="dateiHochladenOnError($event)"
					(success)="dateiHochladenOnSuccess($event)"
					(canceled)="dateiHochladenOnCanceled($event)">
		  </dropzone>
		</div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">

		<button mat-raised-button type="button" mat-dialog-close [disabled]="seconddialogrunningajaxcall">{{ 'allgemein.abbrechen' | translate:locale.language }}</button>
		<button mat-raised-button type="button" (click)="dateiHochladen(uploadImageContainer, dropzoneConfig)" color="primary" [disabled]="seconddialogrunningajaxcall">
		<mat-spinner *ngIf="seconddialogrunningajaxcall" color="primary" mode="indeterminate"></mat-spinner>
		{{ (seconddialogrunningajaxcall ? 'allgemein.daten.verarbeiten' : 'allgemein.hochladen' ) | translate:locale.language:{ typ: 'bild.typ' | translate:locale.language } }}
		</button>

    </mat-dialog-actions>
	</div>
</div>

